// Loons granted to every new account. The backend grants it at signup, and the
// welcome step shows the same amount, so achievement rewards earned during
// signup (e.g. Connect Twitch) are not counted into the welcome.
import { getMarchMadnessActiveTier } from './marchMadness';
export const SIGNUP_LOONS = 4;
export const getSignupLoons = (now) => getMarchMadnessActiveTier(now)?.loons ?? SIGNUP_LOONS;
//# sourceMappingURL=signupLoons.js.map